import Q7 from './Q7';

export default Q7;
